import script from "./DashboardGridUtilization.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardGridUtilization.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardGridUtilization.vue?vue&type=style&index=0&id=0bb2fe14&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb2fe14"]])

export default __exports__